import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getPersonioAttendanceTypeTranslationKey(
	type: Enums<"attendanceType">,
): TranslationKey {
	switch (type) {
		case "work":
			return "users.attendance_type.work";
		case "break":
			return "users.attendance_type.break";
	}
}
